import React, { useEffect, useState } from 'react';
import './style.css';
import LabBackupInfo from '../../../pages/remoteControl/LabBackupInfo';
import LabProcess from '../../../pages/remoteControl/LabProcess';
import GeneralLabInfo from '../../../pages/remoteControl/GeneralLabInfo';
import Feedback from '../../../pages/remoteControl/Feedback';
import ClientComputerInformation from '../../../pages/remoteControl/ClientComputerInformation';
import MiscellaneousFunctions from '../../../pages/remoteControl/MiscellaneousFunctions/miscellaneousFunctions';
import UsersList from '../../../pages/remoteControl/UsersList';
import LabBackupLogs from '../../../pages/remoteControl/LabBackupLogs';
import TicketList from '../../../pages/remoteControl/Tickets/TicketList';
import PerformanceReport from '../../../pages/remoteControl/PerformanceReports/PerformanceReport';
import ParsicServiceLog from '../../../pages/remoteControl/ParsicServiceLog';
import { useAppSelector } from '../../../redux/store/storehooks';
import ParsicMasterInfo from '../../../pages/remoteControl/ParsicMasterInfo';
import SMSList from '../../../pages/remoteControl/SMSList';
import VoipLogs from '../../../pages/remoteControl/voipLogs';
import VoipManagement from '../../../pages/remoteControl/voipManagment';
import ParsinkConfig from '../../../pages/remoteControl/ParsinkConfig/ParsinkConfig';
import ModifyLink from '../../../pages/remoteControl/ModifyLink';
import SpeedTest from '../../../pages/remoteControl/SpeedTest/SpeedTest';
import OnlinePaymentReport from '../../../pages/remoteControl/OnlinePaymentReport';
import SepasReport from '../../../pages/remoteControl/SepasReport';
import ParsicSMSManagement from '../../../pages/remoteControl/ParsicSMS/ParsicSMSManagement';

export interface InputProps {
  url: any,
  labId: any,
  service_url: any
  isOpen?: boolean;
  setIsOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}

const Tab = ({ url, labId, service_url, isOpen = false, setIsOpen}: InputProps) => {
  const [activeTab, setActiveTab] = useState(0);
  const myStore = useAppSelector((state) => state)
  const [permission, setPermission] = useState(false);


  const handleTabClick = (id: any) => {
    setActiveTab(id);
  };

  useEffect(() => {
    //setPermission(true);
    
    if (myStore.auth.loginType === 'parsicuser') {
      myStore.auth.permission.map((item: any) => {
        if (item.pageName == 'proxyPol' && item.maskId == 1)
          setPermission(true);
      });
    }
    else {
      setPermission(true);
    }
  }, [])

  return (
    <div>
      <ul className={isOpen ? "tabs open" : "tabs"}>
        <div className='d-flex justify-content-between position-sticky top-0 pt-4 '>
          <div className='closeIcon' onClick={() => setIsOpen!(prev => !prev)}></div>
        </div>
        <li className={activeTab === 1 ? 'active' : ''} onClick={() => handleTabClick(1)}>اطلاعات بکاپ</li>
        <li className={activeTab === 2 ? 'active' : ''} onClick={() => handleTabClick(2)}>لاگ بکاپ</li>
        <li className={activeTab === 3 ? 'active' : ''} onClick={() => handleTabClick(3)}>اطلاعات سیستم‌ها</li>
        <li className={activeTab === 4 ? 'active' : ''} onClick={() => handleTabClick(4)}>اطلاعات کلی آزمایشگاه</li>
        <li className={activeTab === 5 ? 'active' : ''} onClick={() => handleTabClick(5)}>توابع متفرقه </li>
        <li className={activeTab === 6 ? 'active' : ''} onClick={() => handleTabClick(6)}>فرآیند آزمایشگاه</li>
        <li className={activeTab === 7 ? 'active' : ''} onClick={() => handleTabClick(7)}>فیدبک</li>
        <li className={activeTab === 10 ? 'active' : ''} onClick={() => handleTabClick(10)}>تیکت های آزمایشگاه</li>
        <li className={activeTab === 14 ? 'active' : ''} onClick={() => handleTabClick(14)}> پیامک‌ها </li>
        <li className={activeTab === 16 ? 'active' : ''} onClick={() => handleTabClick(16)}>  پارسینک کانفیگ </li>
        <li className={activeTab === 20 ? 'active' : ''} onClick={() => handleTabClick(20)}>  گزارش سپاس </li>
        <li className={activeTab === 9 ? 'active' : ''} onClick={() => handleTabClick(9)}>لاگ ویپ‌ها</li>
        <li className={activeTab === 8 ? 'active' : ''} onClick={() => handleTabClick(8)}>لیست کاربران</li>
        <li className={activeTab === 11 ? 'active' : ''} onClick={() => handleTabClick(11)}> گزارش راندمان سیستم در مرحله حضوری </li>
        <li className={activeTab === 12 ? 'active' : ''} onClick={() => handleTabClick(12)}> لاگ پارسیک سرویس      </li>
        <li className={activeTab === 13 ? 'active' : ''} onClick={() => handleTabClick(13)}> اطلاعات پارسیک مستر      </li>
        <li className={activeTab === 15 ? 'active' : ''} onClick={() => handleTabClick(15)}> صفحه مدیریت ویپ ها </li>
        <li className={activeTab === 17 ? 'active' : ''} onClick={() => handleTabClick(17)}>اصلاح لینک </li>
        <li className={activeTab === 18 ? 'active' : ''} onClick={() => handleTabClick(18)}>تست سرعت  </li>
        <li className={activeTab === 19 ? 'active' : ''} onClick={() => handleTabClick(19)}>گزارش پرداخت آنلاین   </li>
        <li className={activeTab === 21 ? 'active' : ''} onClick={() => handleTabClick(21)}> ParsicSMS مدیریت</li>
        </ul>

      <div className="tab_content">
        {
          activeTab === 1 && <div className="tab_panel">
            <LabBackupInfo url={url} />
          </div>
        }
        {
          activeTab === 2 && <div className="tab_panel">
            <LabBackupLogs url={url} />
          </div>
        }
        {activeTab === 3 && <div className="tab_panel"><ClientComputerInformation url={url} /> </div>}
        {activeTab === 4 && <div className="tab_panel">  <GeneralLabInfo url={url} /></div>}
        {activeTab === 5 && <div className="tab_panel"> <MiscellaneousFunctions url={url} />  </div>}
        {
          activeTab === 6 &&
          <div className="tab_panel">
            <LabProcess url={url} />
          </div>
        }
        {activeTab === 7 && <div className="tab_panel">  <Feedback url={url} /></div>}
        {activeTab === 8 && <div className="tab_panel">  <UsersList url={url} /></div>}
        {activeTab === 9 && <div className="tab_panel">  <VoipLogs labId={labId} /> </div>}
        {activeTab === 10 && <div className="tab_panel">  <TicketList labId={labId} fromDate={''} toDate={''} tableShow={true} /></div>}
        {activeTab === 11 && <div className="tab_panel">  <PerformanceReport url={url} service_url={service_url} />      </div>}
        {activeTab === 12 && <div className="tab_panel">  <ParsicServiceLog />      </div>}
        {activeTab === 13 && <div className="tab_panel"><ParsicMasterInfo permission={permission} /> </div>}
        {activeTab === 14 && <div className="tab_panel"><SMSList url={url} />   </div>}
        {activeTab === 15 && <div className="tab_panel"><VoipManagement permission={true} labId={labId}/></div>}
        {activeTab === 16 && <div className="tab_panel"><ParsinkConfig labId={labId}/></div>}
        {activeTab === 17 && <div className="tab_panel"><ModifyLink labId={labId}/></div>}
        {activeTab === 18 && <div className="tab_panel"><SpeedTest url={url}/></div>}
        {activeTab === 19 && <div className="tab_panel"><OnlinePaymentReport url={service_url}/></div>}
        {activeTab === 20 && <div className="tab_panel"><SepasReport url={service_url}/></div>}
        {activeTab === 21 && <div className="tab_panel"><ParsicSMSManagement url={url}/></div>}

      </div>
    </div>
  );
};

export default Tab;